/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RelationshipChange
 */
export interface RelationshipChange {
    /**
     * 
     * @type {string}
     * @memberof RelationshipChange
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof RelationshipChange
     */
    entityType: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelationshipChange
     */
    newParentId: string;
    /**
     * 
     * @type {string}
     * @memberof RelationshipChange
     */
    foreignKeyField: string | null;
}

/**
 * Check if a given object implements the RelationshipChange interface.
 */
export function instanceOfRelationshipChange(value: object): value is RelationshipChange {
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('newParentId' in value) || value['newParentId'] === undefined) return false;
    if (!('foreignKeyField' in value) || value['foreignKeyField'] === undefined) return false;
    return true;
}

export function RelationshipChangeFromJSON(json: any): RelationshipChange {
    return RelationshipChangeFromJSONTyped(json, false);
}

export function RelationshipChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelationshipChange {
    if (json == null) {
        return json;
    }
    return {
        
        'entityId': json['entityId'],
        'entityType': json['entityType'],
        'newParentId': json['newParentId'],
        'foreignKeyField': json['foreignKeyField'],
    };
}

export function RelationshipChangeToJSON(json: any): RelationshipChange {
    return RelationshipChangeToJSONTyped(json, false);
}

export function RelationshipChangeToJSONTyped(value?: RelationshipChange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityId': value['entityId'],
        'entityType': value['entityType'],
        'newParentId': value['newParentId'],
        'foreignKeyField': value['foreignKeyField'],
    };
}

